import "react-international-phone/style.css";

import { TextFieldProps, InputAdornment, MenuItem, Select, TextField, Typography } from "@mui/material";
import React from "react";
import {
  CountryData,
  CountryIso2,
  defaultCountries,
  FlagImage,
  PhoneInputProps,
  parseCountry,
  usePhoneInput,
} from "react-international-phone";
import { useTranslations } from "next-intl";
import { AppContext } from "@patron/utils/context";

/**
 * @deprecated This composite is deprecated in favor of the {@link PhoneComponent}.
 */
export type CustomTelephonenumberComponentProps = TextFieldProps &
  PhoneInputProps & {
    value: string;
    onCustomChange?: (phone: string) => void;
    countries?: CountryData[];
    disabled?: boolean;
    showDropDown?: boolean;
  };

/**
 * @deprecated This composite is deprecated in favor of the {@link PhoneComponent}.
 */
export const CustomTelephonenumberComponent = ({
  value,
  onCustomChange,
  disabled,
  countries,
  showDropDown = true,
  ...restProps
}: CustomTelephonenumberComponentProps) => {
  const { localAppState } = React.useContext(AppContext);

  const { config } = localAppState.tenantCompanyDetails;
  // const disablePhonenumberFormatting = config?.global?.disablePhonenumberFormatting || false;
  const disablePhonenumberFormatting = false;
  const t = useTranslations("labels");
  const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } = usePhoneInput({
    defaultCountry: "nl",
    disableCountryGuess: disablePhonenumberFormatting,
    disableDialCodeAndPrefix: disablePhonenumberFormatting,
    disableDialCodePrefill: disablePhonenumberFormatting,
    disableFormatting: disablePhonenumberFormatting,
    ...restProps,
    value,
    countries: countries || defaultCountries,
    onChange: (data) => {
      //if flag added for isDirty flag on empty fields, it will add country prefix and flag as dirty otherwise
      if (inputValue !== "" && inputValue != data.inputValue) {
        onCustomChange(data.phone);
      }
    },
  });
  return (
    <TextField
      variant={restProps.variant || "filled"}
      label={restProps.label || t("labels.phoneNumber")}
      color="primary"
      placeholder="Phone number"
      value={inputValue}
      onChange={(event) => (disablePhonenumberFormatting ? onCustomChange(event.target.value) : handlePhoneValueChange(event))}
      disabled={disabled}
      inputRef={inputRef}
      slotProps={{
        input: {
          startAdornment: !disablePhonenumberFormatting ? (
            <InputAdornment position="start" style={{ marginRight: "2px", marginLeft: "-8px", marginTop: "10px" }}>
              <Select
                variant="outlined"
                MenuProps={{
                  style: {
                    height: "300px",
                    width: "360px",
                    //   top: '10px',
                    //   left: '-34px',
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                }}
                sx={{
                  width: "max-content",
                  // Remove default outline (display only on focus)
                  fieldset: {
                    display: "none",
                  },
                  '&.Mui-focused:has(div[aria-expanded="false"])': {
                    fieldset: {
                      display: "block",
                    },
                  },
                  // Update default spacing
                  ".MuiSelect-select": {
                    padding: "8px",

                    paddingRight: "24px !important",
                  },
                  svg: {
                    right: 0,
                  },
                }}
                value={country.iso2}
                onChange={(e) => setCountry(e.target.value as CountryIso2)}
                renderValue={(renderValue) => <FlagImage iso2={renderValue} style={{ display: "flex" }} />}
              >
                {defaultCountries.map((c) => {
                  const parsedCountry = parseCountry(c);
                  return (
                    <MenuItem key={parsedCountry.iso2} value={parsedCountry.iso2}>
                      <FlagImage iso2={parsedCountry.iso2} style={{ marginRight: "8px" }} />
                      <Typography marginRight="8px">{parsedCountry.name}</Typography>
                      <Typography color="gray">+{parsedCountry.dialCode}</Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </InputAdornment>
          ) : null,
        },
      }}
      {...restProps}
    />
  );
};
